// extracted by mini-css-extract-plugin
module.exports = {"card":"feature-card_card__xJuuA","title":"feature-card_title__D9a56","body":"feature-card_body__pIDRT"};